import { create } from 'zustand'

export const useStore = create((set) => ({
  step: 1,
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  website: '',
  company: '',
  location: '',
  offer: '',
  hasSubmitted: false,
  setHasSubmitted: (hasSubmitted) => set(() => ({ hasSubmitted })),
  increaseStep: (by) => set((state) => ({ step: state.step + by })),
  setLocation: (location) => set(() => ({ location })), 
  setFirstName: (firstName) => set(() => ({ firstName })),
  setLastName: (lastName) => set(() => ({ lastName })),
  setEmail: (email) => set(() => ({ email })),
  setPhone: (phone) => set(() => ({ phone })),
  setCompany: (company) => set(() => ({ company })),
  setWebsite: (website) => set(() => ({ website })),
  setOffer: (offer) => set(() => ({ offer })),
}))